@if (size === 'small') {
  @if (block) {
    <div class="value" [ngClass]="classes" [ngStyle]="style">
      <ng-container *ngTemplateOutlet="smallContent"></ng-container>
    </div>
  }
  @if (!block) {
    <span class="value" [ngClass]="classes" [ngStyle]="style">
      <ng-container *ngTemplateOutlet="smallContent"></ng-container>
    </span>
  }
  <ng-template #smallContent>
    @if (icon) {
      <mat-icon class="icon" [svgIcon]="icon"></mat-icon>
    }
    <span [ngClass]="{ 'ml-half': icon && value }">{{ value }} {{ suffix }}</span>
    @if (subtitle) {
      <span [ngClass]="{ 'm-0': value === undefined }" class="subtitle">{{ subtitle }}</span>
    }
  </ng-template>
}

@if (size === 'large') {
  <div class="large-container">
    <div fxLayout="column" class="value large" [ngClass]="classes" [ngStyle]="style">
      @if (header) {
        <div class="header-container mb-half">{{ header }}</div>
      }
      @if (icon) {
        <mat-icon class="icon" [svgIcon]="icon"></mat-icon>
      }
      <div class="value-container bold">{{ value }} {{ suffix }}</div>
      @if (subtitle) {
        <span [ngClass]="{ 'm-0': value === undefined }" class="subtitle">{{ subtitle }}</span>
      }
    </div>
  </div>
}
